import { dirtyAreaName } from './types';

export const selectDirty = (state: any): boolean => state[dirtyAreaName].value;
export const selectOpen = (state: any): boolean => state[dirtyAreaName].dialog.open;
export const selectConfirmClicked = (state: any): boolean => state[dirtyAreaName].dialog.confirmClicked;
export const selectCancelClicked = (state: any): boolean => state[dirtyAreaName].dialog.cancelClicked;
export const selectTitle = (state: any): string => state[dirtyAreaName].dialog.title;
export const selectContent= (state: any): string => state[dirtyAreaName].dialog.content;
export const selectIssuer = (state: any): string => state[dirtyAreaName].dialog.issuer;